import AppRouter from "./components/app-routing/AppRouter";
import { UserProvider } from "./storage/providers/UserProvider";

const App = () => {
  return (
    <>
      <UserProvider>
        <AppRouter />
      </UserProvider>
    </>
  );
};
export default App;
